import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FastImage from 'react-native-fast-image';
import {css} from 'styled-components/native';

export const ModalContainer = styled.View``;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.shape};

  border-radius: ${RFValue(20)}px;
  padding-bottom: ${RFValue(16)}px;
`;

export const CloseIconButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(12)}px;
  right: ${RFValue(12)}px;
  z-index: 2;
`;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const ModalBody = styled.View`
  padding: 0 ${RFValue(16)}px;
  margin-top: ${RFValue(16)}px;
`;
export const ModalTitle = styled.Text`
  text-align: left;
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.black};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalText = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Grid = styled.View``;
export const Row = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
`;

interface ColumnPosition {
  right?: boolean;
}

interface BankActive {
  active?: boolean;
}

export const Column = styled.View<ColumnPosition>`
  width: 50%;
  flex: 1;
  margin-right: ${RFValue(6)}px;

  ${({right}) =>
    right &&
    css`
      margin-right: 0px;
      margin-left: ${RFValue(6)}px;
    `}
`;
export const BankItem = styled.TouchableOpacity<BankActive>`
  height: ${RFValue(45)}px;
  border-radius: ${RFValue(8)}px;
  border: 1px solid ${({theme}) => theme.colors.border_light};
  justify-content: center;
  background-color: ${({theme}) => theme.colors.shape};
  align-items: center;

  ${({active}) =>
    active &&
    css`
      border-color: ${({theme}) => theme.colors.primary};
      border-width: 2px;
    `}
`;

//@ts-ignore
export const BankImage = styled(FastImage)`
  width: ${RFValue(76)}px;
  height: ${RFValue(21)}px;
`;

export const ModalFooter = styled.View`
  padding: 0 ${RFValue(16)}px;
  margin-top: ${RFValue(16)}px;
`;

export const CheckItemContainer = styled.View`
  width: ${RFValue(18)}px;
  height: ${RFValue(18)}px;
  justify-content: center;
  position: absolute;
  left: 50%;
  margin-left: -${RFValue(9)}px;
  align-items: center;
  bottom: -${RFValue(9)}px;
  border-radius: ${RFValue(25)}px;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const CheckItem = styled(Feather)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.shape};
`;
